export default "__VITE_PUBLIC_ASSET__d86b8c1c__"